module.exports = __webpack_public_path__ + "static/media/our_groups_navcard.e7d1654b.jpg";